enum SupportJumpRealtimeAPIEventTypeEnum {
  MobileSupporterTokensNotification = 'MobileSupporterTokensNotification',
}

export default SupportJumpRealtimeAPIEventTypeEnum;
